/** Whether strategy KPI weights are valid for save/update (empty OK; if any KPIs, total must be 100%). */
export function getStrategyKpiSaveReadiness(strategyKpis = []) {
  const kpis = Array.isArray(strategyKpis) ? strategyKpis : [];
  const total = kpis.reduce((sum, kpi) => sum + Number(kpi.percent || 0), 0);

  if (!kpis.length) {
    return { canSave: true, total: 0, message: "" };
  }

  if (total !== 100) {
    return {
      canSave: false,
      total,
      message: `KPI weights must total exactly 100% (currently ${total}%). Adjust weights before saving.`,
    };
  }

  return { canSave: true, total, message: "" };
}

export const MUST_RESPOND_BY_UNIT_OPTIONS = [
  { value: "minutes", label: "Minutes" },
  { value: "hours", label: "Hours" },
  { value: "days", label: "Days" },
  { value: "weeks", label: "Weeks" },
];

/** Default tender allocation by carrier performance rank (% should sum to 100). */
export const DEFAULT_ALLOCATION_WEIGHTS = Object.freeze([
  { rank: 1, weightPct: 60, color: "#3b82f6" },
  { rank: 2, weightPct: 30, color: "#22c55e" },
  { rank: 3, weightPct: 10, color: "#a855f7" },
]);

/** KPIs users can drag into the active strategy (pool). `name` feeds scoring_spec keys via parity mappers. */
export const KPI_LIBRARY = Object.freeze([
  { id: "on_time", name: "On-Time Performance" },
  { id: "acceptance", name: "Acceptance Rate" },
  { id: "price", name: "Price Efficiency" },
  { id: "claims_free", name: "Claims-Free Ratio" },
  { id: "capacity", name: "Capacity Match" },
  { id: "transit", name: "Transit Time" },
]);

/**
 * Single price-oriented tender strategy template.
 * `basis` resolves against strategy type metadata (typically RANK on the server).
 */
export const STRATEGY_LIBRARY = Object.freeze([
  Object.freeze({
    key: "price-based",
    title: "Tender Strategy",
    subtitle: "Carrier assignment using price-aware scoring and weighted KPIs",
    basis: "RANK",
    /** Ranked tender strategies use weighted split across performance ranks (persisted as `allocation_weights`). */
    allocationMode: "WEIGHTED",
    minLeadTimeHrs: 2,
    maxLeadTimeHrs: 72,
    mustRespondByValue: 72,
    mustRespondByUnit: "hours",
    allocationWeights: DEFAULT_ALLOCATION_WEIGHTS.map((w) => ({ ...w })),
    kpis: [
      { name: "On-Time Performance", percent: 40 },
      { name: "Acceptance Rate", percent: 30 },
      { name: "Price Efficiency", percent: 20 },
      { name: "Claims-Free Ratio", percent: 10 },
    ],
  }),
]);
